/* eslint-disable no-script-url */
import React, { useEffect, useState } from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"

import "./BannerSearch.scss"
import { Container, Form } from "react-bootstrap"

import useDeviceMedia from "@hooks/useDeviceMedia"
import SearchType from "../SearchResults/FilterBox/Sections/SearchType"
import SearchArea from "../SearchResults/FilterBox/Sections/SearchArea"
import FilterMenu from "../SearchResults/FilterBox/FilterMenu"

const {
  createResultsUrl,
} = require("../../gatsby-library-common/PropertySearchNew")

const BannerSearch = ({
  bannerRef,
  showFilter,
  setShowFilter,
  setToggleSearch,
  areaVal,
}) => {
  const searchRef = React.useRef(null)
  const { isMobile } = useDeviceMedia()

  const [srchTypeVal, setSrchTypeVal] = useState("sales")
  const [srchTypeValSel, setSrchTypeValSel] = useState("")
  const [departmentVal, setDepartmentVal] = useState("residential")
  const [minPriceVal, setMinPriceVal] = useState("")
  const [maxPriceVal, setMaxPriceVal] = useState("")
  const [bedroomVal, setBedroomVal] = useState("")
  const [propertyVal, setPropertyVal] = useState("")
  const [areaInputVal, setAreaInputVal] = useState(areaVal || "")
  // eslint-disable-next-line react/hook-use-state
  const [showSuggestion, setShowSuggestion] = useState(true)
  const [milesVal, setMilesVal] = useState("")

  const data = useStaticQuery(graphql`
    query {
      strapiPropertySearch {
        ...PropertySearchFragment
      }
    }
  `)

  const propertySearch = data?.strapiPropertySearch

  // Set background color of search filter to match the background color of the sibling element
  useEffect(() => {
    if (bannerRef?.current) {
      const bannerElement = bannerRef?.current
      const sibling = bannerElement?.nextElementSibling

      if (!sibling) return

      const siblingStyles = window.getComputedStyle(sibling)

      const searchFilter = searchRef?.current

      if (
        siblingStyles.backgroundColor &&
        siblingStyles.backgroundColor !== "rgba(0, 0, 0, 0)"
      ) {
        searchFilter.style.backgroundColor = siblingStyles.backgroundColor
      } else if (siblingStyles?.background?.includes("linear-gradient")) {
        searchFilter.style.backgroundColor = "#F8F8F8"
      }
    }
  }, [bannerRef, searchRef])

  useEffect(() => {
    if (isMobile) {
      if (showFilter) {
        window.scrollTo(0, 0)
        document.body.style.overflowY = "hidden"
      } else {
        document.body.style.overflowY = "auto"
      }
    }
  }, [showFilter, isMobile])

  const handleSearchType = (val) => {
    setSrchTypeValSel(val)
    const splitVal = val.split("-")
    if (splitVal.length > 1) {
      setDepartmentVal(splitVal[0])
      setSrchTypeVal(splitVal[1])
    } else {
      setDepartmentVal("residential")
      setSrchTypeVal(val)
    }
  }

  // Set search type based on the url
  useEffect(() => {
    const pathName = window.location.pathname

    if (pathName.includes("landlords") || pathName.includes("rent")) {
      handleSearchType("residential-lettings")
    } else {
      handleSearchType("residential-sales")
    }
  }, [])

  const onFilterSubmit = (searchParams) => {
    const path = createResultsUrl(searchParams)
    setToggleSearch(false)
    navigate(path)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    setShowSuggestion(false)
    // console.log("event", event)
    const splitArea = areaInputVal.split(",")

    const formFields = {
      areaVal: splitArea[0],
      departmentVal,
      bedVal: bedroomVal,
      minpriceVal: minPriceVal,
      maxpriceVal: maxPriceVal,
      buildingval: propertyVal,
      srchTypeVal,
      radiusVal: milesVal,
    }

    onFilterSubmit(formFields)
  }

  const priceOptions =
    srchTypeVal === "sales"
      ? propertySearch?.sales_price_list
      : propertySearch?.rent_price_list

  // console.log("showFilter", showFilter)

  return (
    <div
      className={`banner-search-section ${showFilter ? "d-block" : ""}`}
      ref={searchRef}
    >
      <Container className="banner-search-container">
        <Form onSubmit={handleSubmit} action="javascript:;">
          <div className="search-filter-wrap">
            <SearchType
              selectOptions={propertySearch?.search_type}
              searchTypeVal={srchTypeValSel}
              handleChange={handleSearchType}
              classNameWrapper="react-select-wrap search-type-filter"
            />
            <div className="horizontal-divider" />
            <div className="input-section">
              <div className="icon icon-search" />
              {/* <p className="search-input">Enter your search location</p> */}
              <SearchArea
                areaVal={areaInputVal}
                setAreaInputVal={setAreaInputVal}
                setShowSuggestion={setShowSuggestion}
              />
            </div>
            <div className="horizontal-divider" />

            <FilterMenu
              showFilter={showFilter}
              propertySearch={propertySearch}
              srchTypeVal={srchTypeVal}
              handleSearchType={handleSearchType}
              priceOptions={priceOptions}
              minPriceVal={minPriceVal}
              maxPriceVal={maxPriceVal}
              setMinPriceVal={setMinPriceVal}
              setMaxPriceVal={setMaxPriceVal}
              bedroomVal={bedroomVal}
              setBedroomVal={setBedroomVal}
              propertyVal={propertyVal}
              setPropertyVal={setPropertyVal}
              srchTypeValSel={srchTypeValSel}
              // pathName={pathName}
              setShowFilter={setShowFilter}
              areaVal={areaInputVal}
              setAreaInputVal={setAreaInputVal}
              setShowSuggestion={setShowSuggestion}
              showSuggestion={showSuggestion}
              milesVal={milesVal}
              setMilesVal={setMilesVal}
              filterType="banner"
              departmentVal={departmentVal}
            />
            <div className="filterbtns d-flex">
              <button
                className="filter-button"
                type="button"
                onClick={() => setShowFilter(!showFilter)}
              >
               
                <div className="icon icon-filter d-none d-md-block" />
                <div className="icon icon-filter-white d-md-none" /> 
                <p className="search-input">Filters</p>
              </button>
              <button
                className="button button-primary search-button"
                type="submit"
              >
                Search
              </button>
            </div>

          </div>
        </Form>
      </Container>
    </div>
  )
}

export default BannerSearch
